import { Customer } from 'src/shared/api';
import {
	CustomerDetails,
	CustomerDetailGeneralInformation,
} from './customer-detail.models';

export function customerFormToCustomer(formValue: CustomerDetails): Customer {
	let customer: Customer;
	if (formValue) {
		const {
			documents,
			contractedRates,
			contacts,
			address = {},
			...details
		} = formValue;

		customer = {
			documents,
			contractedRates,
			contacts,
			address,
			...details.generalInfo,
		};
	}
	return customer;
}

export function customerToCustomerForm(
	customer: Customer
): CustomerDetails | null {
	if (customer) {
		return {
			generalInfo: customerToGeneralInfo(customer),
			address: customer.address,
			contractedRates: customer.contractedRates,
			documents: customer.documents || [],
			contacts: customer.contacts || [],
		};
	} else {
		return {
			generalInfo: null,
			address: null,
			documents: [],
			contacts: [],
			contractedRates: null,
		};
	}
}

function customerToGeneralInfo(
	customer: Customer
): CustomerDetailGeneralInformation {
	return {
		id: customer.id,
		companyName: customer.companyName,
		employerIdentificationNumber: customer.employerIdentificationNumber,
		billingEmail: customer.billingEmail,
		flairDocsCustomerId: customer.flairDocsCustomerId,
	};
}
